// HighlightedFlowbiteDatepicker.js
import React, { useEffect, useRef } from 'react';
import { Datepicker } from 'flowbite-react';

const HighlightedFlowbiteDatepicker = ({ selectedDate, onChange, highlightedDates, className }) => {
  const datepickerRef = useRef(null);

  useEffect(() => {
    if (datepickerRef.current) {
      const datepickerElement = datepickerRef.current._datepickerElement;
      
      if (datepickerElement) {
        const highlightDates = () => {
          const dayElements = datepickerElement.querySelectorAll('.datepicker-cell');
          dayElements.forEach(dayElement => {
            const date = new Date(dayElement.dataset.date);
            if (highlightedDates.some(d => d.toDateString() === date.toDateString())) {
              dayElement.classList.add('highlighted-date');
            }
          });
        };

        // Initial highlight
        highlightDates();

        // Highlight dates when the month changes
        const observer = new MutationObserver(highlightDates);
        observer.observe(datepickerElement, { childList: true, subtree: true });

        return () => observer.disconnect();
      }
    }
  }, [highlightedDates]);

  const formatDate = (date) => {
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  return (
    <Datepicker
      ref={datepickerRef}
      value={formatDate(selectedDate)}
      onSelectedDateChanged={onChange}
      className={className}
    />
  );
};

export default HighlightedFlowbiteDatepicker;